import { cx } from '@epam/uui-core'
import { useEffect } from 'react'
import { amplTrack } from '@stlm/common-ui/lib'
import { useAppSelector } from '../../hooks/redux/redux'
import { SidebarPanel } from '../../components/SidebarPanel/SidebarPanel'
import { useInitialSelectedLocation } from '../../hooks/useInitialSelectedLocation'
import { useInitialSelectedPoint } from '../../hooks/useInitialSelectedPoint'
import { LayersFilter } from './components/LayersFilter/LayersFilter'
import { MapContainer } from './components/MapContainer/MapContainer'
import { MapMenu } from './components/MapMenu/MapMenu'
import { MenuBar } from './components/MenuBar/MenuBar'
import css from './MainPage.module.scss'

type IMainPage = {
  isPlatform: boolean | string
}

export const MainPage = ({ isPlatform }: IMainPage) => {
  const mapHeight = isPlatform ? 'withoutHeader' : 'withHeader'
  const className = cx(css.mainPanel, css[mapHeight])

  const { currentTabSelected } = useAppSelector((state) => state.app)

  useInitialSelectedPoint()
  useInitialSelectedLocation()

  useEffect(() => {
    amplTrack({ name: 'map_pv' })
  }, [])

  return (
    <div className={className}>
      <SidebarPanel />
      {currentTabSelected === 'locations' && (
        <MenuBar>
          <LayersFilter />
        </MenuBar>
      )}
      <MapContainer />
      <MapMenu />
    </div>
  )
}
